import Vue from '@/main'
import i18n from '@/plugins/i18n'

const state = {
  appName: i18n.t('general.name'),
  account: '',
  instructionStep: 1,
  kpi: false,
  debrief: false,
  notification: {
    show: false,
    success: true,
    message: ''
  },
  langs: ['fr', 'en']
}

const getters = {
  account: state => state.account
}

const actions = {
  changeLang (lang) {
    Vue.$i18n.locale = lang
    Vue.$vuetify.lang.current = lang
  }
}

const mutations = {

  SET_notification (state, {success, message}) {
    state.notification.show = true
    state.notification.success = success
    state.notification.message = message
  },

  UNSET_notification (state) {
    state.notification.show = false
    state.notification.message = ''
  },

  SET_kpi (state, val) {
    state.kpi = val
  },

  SET_debrief (state, val) {
    state.debrief = val
  },

  SET_instructionStep (state, val) {
    state.instructionStep = val
  },
  
  SET_account (state, val) {
    state.account = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}